import type { OwnerView } from "@highmarch/app";
import { icon } from "../iconsKit";
import { betterSockets, ownerGroups, ownerKey } from "./armouryModel";
import { ownerArt, ownerName } from "./paperDoll";

/** One owner tile: portrait, name, four rarity pips (what it wears, readable without a tap), ⚡ gear power, and a dot
 *  counting the sockets the stash improves (red on the line-up, which the next level counts; grey on the bench). */
function tileHtml(v: OwnerView, selected: boolean, lineup: boolean): string {
  const art = ownerArt(v);
  const key = ownerKey(v.owner);
  const name = ownerName(v);
  if (!v.owned) {
    return `<button type="button" class="otile lockd${selected ? " sel" : ""}" data-o="${key}" aria-pressed="${selected}" aria-label="${name}, unlocks at level ${v.unlockLevel}">${art ? `<img decoding="async" src="${art}" alt="">` : ""}<i class="lk">${icon("lock", 13)}</i><span class="nm">${name}</span><span class="pw">Lv ${v.unlockLevel}</span></button>`;
  }
  const pips = v.sockets.map((s) => `<i class="${s.worn ? `r${s.worn.rarity}` : "e"}"></i>`).join("");
  const n = betterSockets(v);
  const dot = n > 0 ? `<i class="dot${lineup ? "" : " mute"}">${n}</i>` : "";
  const worn = v.sockets.filter((s) => s.worn).length;
  return `<button type="button" class="otile${selected ? " sel" : ""}${lineup ? "" : " bench"}" data-o="${key}" aria-pressed="${selected}" aria-label="${name}, ${worn} of ${v.sockets.length} worn, gear ${v.power}${n > 0 ? `, ${n} can improve` : ""}">${art ? `<img decoding="async" src="${art}" alt="">` : ""}<span class="nm">${name}</span><span class="pips">${pips}</span><span class="pw">${icon("bolt", 11)}<b>${v.power}</b></span>${dot}</button>`;
}

/**
 * The owner strip: "Level N line-up" (the fortress, then the level's seats), sized so the whole line-up fits the
 * width with nothing cut off; then the bench and the locked types, one sideways scroll away ("Bench ›" jumps there).
 */
export function ownerStripHtml(views: readonly OwnerView[], selected: string, level: number): string {
  const g = ownerGroups(views);
  const lineup = g.lineup.map((v) => tileHtml(v, ownerKey(v.owner) === selected, true)).join("");
  const benched = [...g.bench, ...g.locked];
  const rest = benched.map((v) => tileHtml(v, ownerKey(v.owner) === selected, false)).join("");
  const jump = rest ? `<button type="button" class="tobench" aria-label="Bench: ${benched.length} towers">Bench <b>${benched.length}</b>${icon("chev", 12)}</button>` : "";
  return `<div class="arm-owners${g.lineup.length >= 6 ? " dense" : ""}" style="--n:${Math.max(1, g.lineup.length)}"><div class="track">
    <div class="og lineup"><small>${icon("flag", 12)} Level ${level} line-up${jump}</small><div class="tiles">${lineup}</div></div>
    ${rest ? `<div class="og bench"><small>Bench</small><div class="tiles">${rest}</div></div>` : ""}
  </div></div>`;
}
